import React, { useEffect, useState } from 'react';

import { getLastTransaction } from '@api/FW/transactions/lastTransaction';
import { apiErrorHandler } from '@app/services/error.service';
import { LastTransactions } from '@FW/interfaces/transactions/LastTransactions';
import { getWalletTransactionsColumns } from '@FW/pages/Wallet/Transactions/components/Columns';
import { useAppSelector } from '@hooks/shared/reduxHooks';
import { useResponsive } from '@hooks/shared/useResponsive';
import { Container } from '@styled/shared/Container';
import { mobileTableRender } from '@utils/shared/table/mobileTableRenderer';
import { Button, Flex, Skeleton, Table, Typography } from 'antd';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const LastTransaction = () => {
	const client = useAppSelector((state) => state.user.client);
	const { mobileOnly, isTablet, isSmallDesktop } = useResponsive();
	const showMobileLayout = mobileOnly || (isTablet && !isSmallDesktop);

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [transactions, setTransactions] = useState<LastTransactions[]>();

	const tableColumns = getWalletTransactionsColumns();

	useEffect(() => {
		if (!client?.counterparty) return;

		getLastTransaction(client.counterparty)
			.then((loadData) => {
				if (!loadData) return;

				setTransactions(loadData);
			})
			.catch((error) => apiErrorHandler(error))
			.finally(() => setIsLoading(false));
	}, [client]);

	return (
		<Container vertical className='content-wrapper' gap={16}>
			<Flex gap={16} wrap='wrap' justify='space-between' align='center'>
				<Text className='block-title'>{t('transactions.lastTransactionTitle')}</Text>
				<Link to='transactions'>
					<Button>{t('transactions.allTransactions')}</Button>
				</Link>
			</Flex>
			<div className='w-full'>
				{isLoading ? (
					<Skeleton.Button style={{ height: '72px' }} className={'block--i w-full--i'} active />
				) : (
					<Table
						tableLayout='fixed'
						columns={showMobileLayout ? tableColumns.slice(0, 2) : tableColumns}
						dataSource={transactions?.map((item, index) => ({ ...item, key: index }))}
						bordered={false}
						pagination={false}
						expandable={
							showMobileLayout
								? {
										expandedRowRender: (row) =>
											tableColumns.slice(2).map((item, index) => mobileTableRender(item, row)),
										expandRowByClick: true,
										indentSize: 15,
									}
								: undefined
						}
					/>
				)}
			</div>
		</Container>
	);
};

export default LastTransaction;
